/**
 * 
 * @author Tim
 * @date 2024-01-04
 */

import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
 
const store = new Vuex.Store({
	state: {
		getConfig:{},  			// 配置信息
		getVersion:0,  			// 版本信息
		getNavBarInfo:{},  		// 状态栏信息
		getPath:"",  			// 路径
		appParams:{},           // 应用参数
		getPointRule: [],       // 积分规则
		userInfo: {},           // 用户信息
		isLoggedIn: false,      // 登录状态
	},
	mutations: {
		setConfig(state, value) {
			state.getConfig = value;
		},
		setVersion(state, value) {
			state.getVersion = value;
		},
		setNavBarInfo(state, value) {
			state.getNavBarInfo = value;
		},
		setPath(state, value) {
			state.getPath = value;
		},
		setAppParams(state, value) {
			state.appParams = value;
		},
		setPointRule(state, value) {
			state.getPointRule = value;
		},
		setUserInfo(state, value) {
			state.userInfo = value;
		},
		setLoginStatus(state, value) {
			state.isLoggedIn = value;
		},
	},
	getters: {
		// 获取应用参数
		getAppParam: (state) => (key, defaultValue = null) => {
			if (!key) return defaultValue;
			return state.appParams.hasOwnProperty(key) ? state.appParams[key] : defaultValue;
		}
	}
})

export default store